import React, {  useEffect, useState } from 'react'
import { Card } from '../../../../../components/ui/Card'
import { DatePickerCustomInput } from '../../../../../components/ui/DatePickerCustomInput'
import { Button } from '../../../../../components/ui/button'
import { DataTableNew } from '../../../../../components/table-components/data-table'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { fetchAssetDetailsAction } from '../../../../../store/actions/user/assetValueAction'
import { Filters } from '../../../../../constant'
import moment from 'moment-js'
import DataTableColumnHeader from '../../../../../components/table-components/data-table-column-header'

const TenureDetailsContents = () => {
    const dispatch = useDispatch()
    const { assetDetailsValueData } = useSelector(state => state)
    const { slug } = useParams();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [reset, setReset] = useState(false);
    const [error, setError] = useState({})
    const location = useLocation();
    const assetData = location.state?.data;

    const onChange = (filter) => {
        assetData && dispatch(fetchAssetDetailsAction({
            page: filter.page,
            perPage: filter.perPage,
            type:"raw",
            startDate:startDate !== null ?  convertDateToFormate(startDate) : null,
            endDate: endDate !== null ?  convertDateToFormate(endDate) : null,            // startDate: filter.startDate ? filter.startDate === null ? '' : filter.startDate : '',
            // endDate: filter.endDate ? filter.endDate === null ? '' : filter.endDate : '',
            assetIds: [assetData?.data?.interestRateDataTypeAsset?._id]
        }))
    }


    const handleDateRangeClick = () => {
        if (startDate !== null && endDate !== null) {
            onChange({
                page: Filters.PAGE,
                perPage: Filters.OBJ.perPage,
                startDate: startDate === null ? '' : moment(startDate).format('YYYY-MM-DD'),
                endDate: endDate === null ? '' : moment(endDate).format('YYYY-MM-DD'),
                assetIds: [assetData?.data?.tenure?._id]
            })
            setError({})
        } else {
            setError({ dataError: 'Please select date range!' })
        }
    }

    const resetDate = () => {
        setStartDate(null);
        setEndDate(null);
    }

    const handleReset = () => {
        resetDate()
        setError({})
        setReset(true)
    }

    useEffect(() => {
        if(reset) {
            onChange({
                page: Filters.PAGE,
                perPage: Filters.OBJ.perPage,
                startDate: null,
                endDate: null,
                assetIds: [assetData?.data?.tenure?._id]
            })
        }
        setReset(false)
    },[reset])

    const keyData = assetDetailsValueData && assetDetailsValueData?.records?.length ? assetDetailsValueData?.records[0] : {};
    const keysName = Object.keys(keyData)
    // const data = assetDetailsValueData && assetDetailsValueData?.records?.length ? assetDetailsValueData?.records.map((item, index) => {
    //     const keys = Object.keys(item)
    //     const values = Object.values(item)
    //     const obj = { ...Object.assign({}, ...keys.map((key, index) => ({ [key]: values[index] }))) };
    //     return obj
    // }) : []

    // const columns = keysName.length ? keysName.map((item) => {
    //     return {
    //         accessorKey: item,
    //         header: item,
    //         cell: ({ row }) => (
    //             <div className="capitalize">{row.original[item]}</div>
    //         ),
    //     }

    // }) : [];

    const columns = [
        {
            accessorKey: "data",
            header: ({ column }) => (
                <DataTableColumnHeader className="capitalize" column={column} title={"Data"} />
            ),
            cell: ({ row }) => {
                return (
                    <div>{row.original?.data}</div>
                )
            },
            enableSorting: true,
        },
        {
            accessorKey: "value",
            header: ({ column }) => (
                <DataTableColumnHeader className="capitalize" column={column} title={"Value"} />
            ),
            cell: ({ row }) => {
                return (
                    <div>{row.original?.value}</div>
                )
            },
            enableSorting: true,
        }
    ] 

    const data = assetDetailsValueData && assetDetailsValueData?.records?.length > 0 ? assetDetailsValueData?.records.map((asset) => {


        return {
            data: new Date(asset?.date)?.toLocaleDateString("en-GB",{
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            }),
            value: asset.value
        }
    
    }) : []



    return (
        <section className='p-2 md:px-5'>
           
            <Card className="bg-white p-3 md:p-5 ">
                <div className="card-head flex items-center gap-2 justify-between mb-4">
                    <h4 className='text-base font-600 text-textV2'>Historical Data</h4>
                </div>
                <div className="table-wrapper">
                    <div className="table-toolbar flex items-center justify-between gap-4 mb-6">
                        <div className="flex items-center gap-4">
                            <label htmlFor="" className='text-textV1 text-xs font-500'>
                                Time Period:
                            </label>
                            <div className="flex items-center gap-4 flex-wrap">
                                <div className="flex items-center gap-4">
                                    <label htmlFor="" className='text-textV1 text-xs font-500'>From</label>
                                    <DatePickerCustomInput onDateSelect={(date) => setStartDate(date)}
                                        placeholderText='YYYY-MM-DD'
                                        selectedFromDate={startDate}
                                        value={startDate}
                                    />
                                </div>
                                <div className="flex items-center gap-4">
                                    <label htmlFor="" className='text-textV1 text-xs font-500'>To</label>
                                    <DatePickerCustomInput onDateSelect={(date) => setEndDate(date)}
                                        placeholderText='YYYY-MM-DD'
                                        minDate={startDate}
                                        selectedFromDate={startDate}
                                        value={endDate}
                                    />
                                </div>
                                <Button size="sm" className="min-w-[98px] hover:bg-[#F5F5F5]" type="submit" variant="outline" disabled={startDate === null || endDate === null} onClick={handleReset}>
                                    Reset
                                </Button>
                                <Button size="sm" className="min-w-[98px] hover:bg-[#F5F5F5]" type="submit" variant="outline" disabled={startDate === null || endDate === null} onClick={() => handleDateRangeClick()}>
                                    Apply
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="table-wrapper">
                        <DataTableNew data={data} columns={columns} onChange={onChange} isSearchHide={true} isCollViewHide={true} filterName={'Name'} isRight={true} />
                    </div>
                </div>
            </Card>
        </section>
    )
}

export default TenureDetailsContents


const convertDateToFormate = (date) => {

    if(!date) {
        return
    }

    return new Date(date).toLocaleDateString("en-CA", {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    })
}